module.exports = __webpack_public_path__ + "static/media/MOF_interior1.e6ff8ec5.jpg";